// extracted by mini-css-extract-plugin
export default {"products":"nA-z","card":"oA-z","oosMessaging":"pA-z"};